import { IVariation } from '~/lib/data-contract';

export const getSizeVariants = (variants: IVariation[], parentColor?: string) => {
	if (!parentColor) {
		return [];
	}

	return variants.reduce<IVariation[]>((prev, curr) => {
		if (curr.color?.colorId !== parentColor) {
			return prev;
		}

		if (prev.find((i) => i.sizeAttribute === curr.sizeAttribute)) {
			return prev;
		}

		return [curr, ...prev];
	}, []);
};
